/**
 * 网络请求配置
 */
import axios from "axios";
import store from "../store";
import getUrlTypePage from '../sensorsdata/getSiteSource';
import { CHANNEL_CODE } from '@/consts/newConsts'
const { getState } = store;

let lykTokenCache = null
let lykTokenFetching = null


const BASE_URL = {
    dev: "",
    test: "https://aitest.3d66.com",
    pro: "https://ai.3d66.com",
};

const API_BASE_URL = {
    dev: "",
    test: "https://apitest.3d66.com",
    pro: "https://api.3d66.com",
};

const SERVICE_API_URL = {
    dev: "",
    test: "https://servicetest.3d66.com/",
    pro: "https://service.3d66.com/",
};

const CAMPAIGN_API_URL = {
    dev: "http://www.dev.3d66.com",
    test: "https://www_dybzp.3d66.com/",
    pro: "https://www.3d66.com",
};

const AI_SEARCH_API_URL = {
    dev: "http://aisearch.dev.3d66.com",
    test: "https://aisearchtest.3d66.com",
    pro: "https://aisearch.3d66.com",
};

const env = process.env.REACT_APP_ENV || 'dev';

// axios.defaults.baseURL = BASE_URL[env];
// axios.defaults.withCredentials=true;

// axios.defaults.timeout = 100000;

const Axios = axios.create({
    baseURL: BASE_URL[env],
    timeout: 1800000,
    withCredentials: true,
});

//   Axios.defaults.withCredentials = true; // 允许携带cookie
//   axios.defaults.withCredentials = true; // 允许携带cookie
//   Axios.defaults.headers.common['headers'] = localStorage.getItem("imToken");
//   Axios.defaults.headers.common['Authorization'] = `Bearer ${getState().app?.userInfo?.accessToken}`

const config = {
    headers: {
        'Authorization': `Bearer ${getState().app?.userInfo?.accessToken}`,
        'headers': localStorage.getItem("imToken")
    }
};


//设置Axios请求头
// Axios.defaults.headers.common['access-source-page'] = window.referrerType || 0;
// Axios.defaults.headers.common['source-type '] = window.currentType || 0;

/**
 * http request 拦截器
 */

let currentType = 0;
if (window.location.href.indexOf('coCreateHomePage') >= 0) {
    currentType = 34;
}
else if (window.location.href.indexOf('inspirationHomePage') >= 0) {
    currentType = 33;
}
else if (window.location.href.indexOf('/pro/Index') >= 0) {
    currentType = 22;
}
else if (window.location.href.indexOf('/pro/Canvas') >= 0) {
    currentType = 23;
}
else {
    currentType = 22;
}
Axios.interceptors.request.use(
    async (config) => {
        const isCampaignImageRequest = config.url.indexOf('/api/v1/campaignImage/list') === 0;
        const isAiSearchTaskRequest = config.url.indexOf('/api/tasks') === 0;
        const isAiSearchFirstVisitRequest = config.url.indexOf('/api/firstvisit') === 0;
        const isPublicRequest = isCampaignImageRequest || isAiSearchTaskRequest || isAiSearchFirstVisitRequest;

        // 运维 禁止了自定义配置请求头
        // config.headers['Source-Site'] = window.accessSourceSite;
        // config.headers['Source-Page'] = window.accessSourcePage;

        // 运营广告和 AI 搜索任务接口是公开接口，不依赖登录态或浏览器 cookie。
        if (isPublicRequest) {
            delete config.headers.imToken;
            delete config.headers['Authorization'];
            config.withCredentials = false;
        } else {
            config.headers.imToken = localStorage.getItem("imToken");
            config.headers['Authorization'] = `Bearer ${getState().app?.userInfo?.accessToken}`;
        }

        // config.data = JSON.stringify(config.data);
        // config.headers['Access-Source-Page'] = window.referrerType || currentType;
        // config.headers['Page-Type ']  = window.currentType || currentType;
        // //debugger;


        // lyk免登录
        let lykUserToken = lykTokenCache
        if (!lykUserToken && !lykTokenFetching) {
            const queryString = (() => {
                if (window.location.search) return window.location.search
                if (window.location.href.includes('?')) return window.location.href.split('?')[1]
                if (window.self !== window.top) {
                    try { return window.top.location.search } catch (e) { /* 跨域iframe */ }
                }
                return ''
            })()
            const urlParams = new URLSearchParams(queryString)
            const aiSource = urlParams.get('ai_source')
            if (aiSource === CHANNEL_CODE.SU || aiSource === CHANNEL_CODE.PS || aiSource === CHANNEL_CODE.MAX) {
                lykTokenFetching = (async () => {
                    try {
                        if (aiSource === CHANNEL_CODE.SU || aiSource === CHANNEL_CODE.MAX) {
                            if (window?.chrome?.webview?.hostObjects?.SuWebUtil) {
                                const SuWebUtil = window.chrome.webview.hostObjects.SuWebUtil
                                const result = await SuWebUtil.GetUserInfo()
                                const info = JSON.parse(result)
                                lykTokenCache = info.user_token
                            }
                        }
                        if (aiSource === CHANNEL_CODE.PS) {
                            // const result = await new Promise((resolve, reject) => {
                            //     const timeout = setTimeout(() => reject(new Error('PS免登录超时')), 5000)
                            //     const handler = (event) => {
                            //         if (event.data?.type === 'GetUserInfo') {
                            //             clearTimeout(timeout)
                            //             window.removeEventListener('message', handler)
                            //             resolve(event.data.result)
                            //         }
                            //     }
                            //     window.addEventListener('message', handler)
                            //     window.parent.postMessage({ type: 'GetUserInfo' }, '*')
                            // })
                            // const info = typeof result === 'string' ? JSON.parse(result) : (result?.data || result)
                            // lykTokenCache = info.user_token

                            if (window?.chrome?.webview?.hostObjects?.PsWebUtil) {
                                const PsWebUtil = window.chrome.webview.hostObjects.PsWebUtil
                                const result = await PsWebUtil.GetUserInfo()
                                const info = JSON.parse(result).Data
                                // console.log('info', info)
                                lykTokenCache = info.user_token
                            }

                            // console.log('lyk-ps免登录成功--')
                        }
                    } catch (error) {
                        console.log(new Error('lyk免登录失败:', error))
                        lykTokenCache = null
                    } finally {
                        lykTokenFetching = null
                    }
                })()
            }
        }

        if (lykTokenFetching) {
            await lykTokenFetching
            lykUserToken = lykTokenCache
        }

        const isServiceApi = config.url.indexOf('/activityunion') >= 0
            || config.url.indexOf('/payment/do_payment') > -1
            || config.url.indexOf('/union_recharge_ab') > -1
            || config.url.indexOf('/pay/') > -1
            || config.url.indexOf('/service/v1/service/oss') > -1

        const is3d66Api = config.url.indexOf('api.3d66.com') > -1
            || config.url.indexOf('apitest.3d66.com') > -1

        // console.log('config.url-------',config,  config.url)
        // console.log('lykUserToken-------', lykUserToken)
        if (lykUserToken && !isPublicRequest) {
            if (isServiceApi) {
                if (config.method === 'get' || config.method === 'delete') {
                    config.params = { ...config.params, 'lyk-token': lykUserToken }
                } else {
                    if (config.data instanceof FormData) {
                        config.data.append('lyk-token', lykUserToken)
                    } else {
                        config.data = { ...config.data, 'lyk-token': lykUserToken }
                    }
                }
            } else {
                config.headers['lyk-token'] = lykUserToken
            }
        }

        if (config.url.indexOf('/api/v1/campaignImage/list') === 0) {
            config.baseURL = CAMPAIGN_API_URL[env];
        }
        else if (config.url.indexOf('/api/tasks') === 0 || config.url.indexOf('/api/firstvisit') === 0) {
            config.baseURL = AI_SEARCH_API_URL[env];
        }
        else if (config.url.indexOf('/service') == 0) {
            // config.baseURL = APIS[config?.apiType];
            config.baseURL = API_BASE_URL[env];
            delete config.headers['imToken'];
        }
        else if (config.url.indexOf('/activityunion') >= 0 || config.url.indexOf('/payment/do_payment') > -1
            || config.url.indexOf('/union_recharge_ab') > -1 || config.url.indexOf('/pay/') > -1) {
            config.baseURL = SERVICE_API_URL[env];
            if (config.url.indexOf('/union_recharge_ab') > -1) {
                config.url = `/api/v1/union_recharge_ab/index?order_type=${config.data.order_type}`
            }
            delete config.headers['imToken'];
        }
        else if (config.url.indexOf('.aliyuncs.com/ai/') >= 0) {
            delete config.headers['imToken'];
        }

        if (isPublicRequest) {
            // 公开接口使用原始请求参数，不追加公共埋点参数。
        }
        else if(config.method === 'get' || config.method === 'delete'){
            let newParam = config.params;
            newParam.accessSourceSite = getUrlTypePage(document.referrer, 'res_type') || window.referrerType;
            newParam.accessSourcePage = getUrlTypePage(document.referrer) || window.referrerType;

            newParam.pageType = window.currentType || currentType;
            newParam.ai_source_2 = getState().app.ai_source;
            config.params = newParam;

            if (config.params.is_banner_skip) { // 广告链接跳转过来获取作品信息时
                let newParam = config.params;
                delete newParam.is_banner_skip;
                delete newParam.pageType;
                config.params = newParam;
            }
        }
        else {
            let newParam = config.data || {};
            newParam.accessSourceSite = getUrlTypePage(document.referrer, 'res_type') || window.referrerType;
            newParam.accessSourcePage = getUrlTypePage(document.referrer) || window.referrerType;
            newParam.pageType = window.currentType || currentType;
            newParam.ai_source_2 = getState().app.ai_source;
            config.data = newParam;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

/**
 * http response 拦截器
 */
Axios.interceptors.response.use(
    (response) => {
        if (response.data.errCode === 2) {
            // console.log("过期");
        }
        return response;
    },
    (error) => {
        // console.log("请求出错：", error);
    }
);

/**
 * 封装get方法
 * @param url  请求url
 * @param params  请求参数
 * @returns {Promise}
 */
export function get(url, params = {}, config = {}) {
    return new Promise((resolve, reject) => {
        Axios.get(url, {
            params: params,
        }, {
            ...config
        }).then((response) => {
            // console.log("get请求参数");
            // landing(url, params, response.data);
            resolve(response.data);
        })
            .catch((error) => {
                reject(error);
            });
    });
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function post(url, data, config = {}) {
    return new Promise((resolve, reject) => {
        Axios.post(url, data, {
            ...config
        }).then(
            (response) => {
                resolve(response?.data);
            },
            (err) => {
                reject(err);
            }
        );
    });
}

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function put(url, data, config = {}) {
    return new Promise((resolve, reject) => {
        Axios.put(url, data, {
            ...config,
        }).then(
            (response) => {
                resolve(response.data);
            },
            (err) => {
                reject(err);
            }
        );
    });
}

/**
 * 封装delete请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function del(url, data) {
    return new Promise((resolve, reject) => {
        Axios.delete(url, {
            params: data,
        }).then(
            (response) => {
                resolve(response.data);
            },
            (err) => {
                reject(err);
            }
        );
    });
}

//统一接口处理，返回数据
export default function http(method, url, param) {
    return new Promise((resolve, reject) => {
        switch (method) {
            case "get":
                get(url, param)
                    .then(function (response) {
                        resolve(response);
                    })
                    .catch(function (error) {
                        reject(error);
                    });
                break;
            case "post":
                post(url, param)
                    .then(function (response) {
                        resolve(response);
                    })
                    .catch(function (error) {
                        reject(error);
                    });
                break;
            case "put":
                put(url, param)
                    .then(function (response) {
                        resolve(response);
                    })
                    .catch(function (error) {
                        reject(error);
                    });
                break;
            case "del":
                del(url, param)
                    .then(function (response) {
                        resolve(response);
                    })
                    .catch(function (error) {
                        reject(error);
                    });
                break;
            default:
                break;
        }
    });
}

/**
 * 查看返回的数据
 * @param url
 * @param params
 * @param data
 */
function landing(url, params, data) {
    if (data.code === -1) {
    }
}
